import React, { ComponentProps, FunctionComponent } from "react";

const CopyIcon = (
  {
    title,
    titleId,
    ...props
  }: { title?: string; titleId?: string } & React.ComponentProps<"svg">,
  svgRef: any
) => {
  return /*#__PURE__*/ React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 12 16",
        fill: "none",
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId,
      },
      props
    ),
    title
      ? /*#__PURE__*/ React.createElement(
          "title",
          {
            id: titleId,
          },
          title
        )
      : null,
    /*#__PURE__*/ React.createElement("path", {
      d: "M8.66669 12.0002V13.3335C8.66669 13.6871 8.52621 14.0263 8.27616 14.2763C8.02611 14.5264 7.68698 14.6668 7.33335 14.6668H2.00002C1.6464 14.6668 1.30726 14.5264 1.05721 14.2763C0.807163 14.0263 0.666687 13.6871 0.666687 13.3335V6.00016C0.666687 5.64654 0.807163 5.3074 1.05721 5.05735C1.30726 4.8073 1.6464 4.66683 2.00002 4.66683H3.33335M3.33335 2.66683V10.6668C3.33335 11.0205 3.47383 11.3596 3.72388 11.6096C3.97393 11.8597 4.31306 12.0002 4.66669 12.0002H10C10.3536 12.0002 10.6928 11.8597 10.9428 11.6096C11.1929 11.3596 11.3334 11.0205 11.3334 10.6668V4.82816C11.3333 4.65054 11.2978 4.4747 11.2289 4.31099C11.16 4.14728 11.059 3.99899 10.932 3.87483L8.72202 1.7135C8.47293 1.46993 8.1384 1.33354 7.79002 1.3335H4.66669C4.31306 1.3335 3.97393 1.47397 3.72388 1.72402C3.47383 1.97407 3.33335 2.31321 3.33335 2.66683Z",
    })
  );
};

const ForwardRef = React.forwardRef(CopyIcon) as FunctionComponent<
  ComponentProps<"svg">
>;

export default ForwardRef;
